import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "size-16"
};
const _hoisted_2 = {
    key: 1,
    class: "text-cl-108"
};
const _hoisted_3 = {
    key: 2,
    class: "text-cl-108"
};
import { ref, onMounted, onUnmounted } from 'vue';
import { LoadMoreIndicatorType } from './common-type';
// MARK: Ref value
export default /*@__PURE__*/ _defineComponent({
    __name: 'load-more-indicator',
    emits: ["loadMore"],
    setup(__props, { expose: __expose, emit: __emit }) {
        const containerRef = ref(null);
        const status = ref(LoadMoreIndicatorType.Loading);
        // MARK: Emit
        const emits = __emit;
        // MARK: Observer
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    disconnectObserver(); // Disconnect to prevent re-trigger
                    emits('loadMore');
                }
            });
        }, {
            root: null,
            rootMargin: '0px',
            threshold: 0,
        });
        // MARK: Lifecycle
        onMounted(() => {
            reconnectObserver();
        });
        onUnmounted(() => {
            disconnectObserver();
        });
        // MARK: Exposed methods
        // Centralized setter controls both status and observer behavior
        // - `type`: the indicator state (Loading, NoData, Complete)
        // - `forceObserve`:
        //     true  => always reconnect the observer (even for Loading)
        //     false => always disconnect the observer (useful while an API call is in flight)
        //     undefined/null => default behavior (Loading reconnects, others disconnect)
        const setStatus = (type, forceObserve) => {
            status.value = type;
            // forceObserve: true => always reconnect, false => always disconnect
            // null/undefined => default: Loading reconnects, others disconnect
            if (forceObserve === true) {
                reconnectObserver();
            }
            else if (forceObserve === false) {
                observer.disconnect();
            }
            else {
                if (type === LoadMoreIndicatorType.Loading) {
                    reconnectObserver();
                }
                else {
                    observer.disconnect();
                }
            }
        };
        const disconnectObserver = () => {
            observer.disconnect();
        };
        const reconnectObserver = () => {
            if (containerRef.value) {
                observer.observe(containerRef.value);
            }
        };
        // MARK: Expose methods
        // Keep RFC-compatible helpers for existing call sites while exposing the new API
        const loading = () => setStatus(LoadMoreIndicatorType.Loading);
        const noData = () => setStatus(LoadMoreIndicatorType.NoData);
        const complete = () => setStatus(LoadMoreIndicatorType.Complete);
        const resetStatus = () => setStatus(LoadMoreIndicatorType.Loading);
        __expose({
            setStatus,
            loading,
            noData,
            complete,
            resetStatus,
            disconnectObserver,
            reconnectObserver,
        });
        return (_ctx, _cache) => {
            const _component_loader_view = _resolveComponent("loader-view");
            return (_openBlock(), _createElementBlock("div", {
                ref_key: "containerRef",
                ref: containerRef,
                class: "flex h-auto w-full items-center justify-center py-4"
            }, [
                (status.value == _unref(LoadMoreIndicatorType).Loading)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        _createVNode(_component_loader_view)
                    ]))
                    : _createCommentVNode("", true),
                (status.value == _unref(LoadMoreIndicatorType).NoData)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, " -- No listing found -- "))
                    : _createCommentVNode("", true),
                (status.value == _unref(LoadMoreIndicatorType).Complete)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, " -- No More Data -- "))
                    : _createCommentVNode("", true)
            ], 512));
        };
    }
});
